import React from 'react';
import {
  Form, Icon, Input, Button, Checkbox, message, Row, Col
} from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { api } from '../config';
import './style.css';

interface Props extends FormComponentProps {
  changeStatus: (data: string) => any;
  userInfo: (data: any) => any;
}

class NormalLoginForm extends React.Component<Props> {
  state = {
    status: 'login',
    clause: false,
    ImgUrl: api.imgUrl
  }
  handleSubmit = (e: any) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (!this.state.clause) {
          message.warning('请阅读并同意《注册条款》')
          return
        }
        this.props.userInfo(values)
        .then(
          (res: any) => {
            if (!res.error) {
              this.props.changeStatus('success')
            }
          }
        )
      }
    });
  }

  compareToFirstPassword = (rule: any, value: any, callback: any) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue('password')) {
      callback('两次密码输入不一致，请重新输入');
    } else {
      callback();
    }
  };

  changeAgree = (e: any) => {
    this.setState({
      clause: e.target.checked
    })
  }

  getImgUrl = (e: any) => {
    e.preventDefault();
    let time = new Date().toISOString();

    this.setState({
      ImgUrl: `${api.imgUrl}?time=${time}`
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.handleSubmit} className="login-form">
        <h1>注册</h1>
        <Form.Item>
          {getFieldDecorator('userName', {
            rules: [{ required: true, message: '请输入用户名!' }],
          })(
            <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="用户名" />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: '请输入密码!' }],
          })(
            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="密码" />
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('confirmPassword', {
            rules: [
              { required: true, message: '请再次输入密码!' },
              {
                validator: this.compareToFirstPassword
              }
            ],
          })(
            <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="密码" />
          )}
        </Form.Item>

        <Row gutter={24}>
          <Col span={12}>
            <Form.Item>
              {getFieldDecorator('captcha', {
                rules: [
                  { required: true, message: '请输入验证码!' }
                ],
              })(
                <Input prefix={<Icon type="safety-certificate" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="验证码" />
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <img src={this.state.ImgUrl} alt="验证码" onClick={this.getImgUrl} style={{width: '100%', paddingTop: 3}}/>
          </Col>
        </Row>

        <Form.Item>
          {getFieldDecorator('remember', {
            valuePropName: 'checked',
            initialValue: false,
          })(
            <Checkbox onChange={this.changeAgree}>我已阅读并同意</Checkbox>
          )}
          <a>《注册条款》</a>
          <div className="login_button">
            <Button type="primary" htmlType="submit" className="login-form-button">
              注册
            </Button>
          </div>

          <a onClick={() => this.props.changeStatus('login')}>登录</a>
        </Form.Item>
      </Form>
    );
  }
}

const Register: any = Form.create({ name: 'normal_login' })(NormalLoginForm);

export default Register;